import { render } from "./EmploymentBulkUploadModal.vue?vue&type=template&id=e87fc6f0&scoped=true"
import script from "./EmploymentBulkUploadModal.vue?vue&type=script&lang=js"
export * from "./EmploymentBulkUploadModal.vue?vue&type=script&lang=js"

import "./EmploymentBulkUploadModal.vue?vue&type=style&index=0&id=e87fc6f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e87fc6f0"

export default script